<template>
  <div id="ChangeRequest">
    <MyHeaderPage
      :title="$t('ticketsList.ChangeRequest.title')"
      :subtitle="$t('ticketsList.ChangeRequest.subTitle')"
    />
    <br /><br />
    <TicketTable
      :service="ChangeRequestService"
      :mobile-component="ChangeRequestCard"
      detail-url-key="nav.reportCrListUrl"
      i18n-namespace="ticketsList.ChangeRequest"
    />
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted } from 'vue'
import MyHeaderPage from '@/components/MyHeaderPage.vue'
import TicketTable from '@/components/Feature/Ticket/TicketTable.vue'
import ChangeRequestCard from '@/components/ChangeRequest/ChangeRequestCard.vue'
import { ChangeRequestService } from '@/services/ChangeRequestService'
import '@/assets/scss/ChangeRequest.scss'

const { proxy } = getCurrentInstance()

onMounted(() => {
  window.scrollTo(0, 0)
  proxy.$IsLoggedIn()
})
</script>
